import { Controller } from "@hotwired/stimulus"

// Makes an element reach the bottom of the window instead of guessing a fraction of it:
// a scrolling board should end where the screen ends, not past it.
export default class extends Controller {
  static values = { min: { type: Number, default: 340 }, gap: { type: Number, default: 24 } }

  connect() {
    this.fit = this.fit.bind(this)
    this.fit()
    window.addEventListener("resize", this.fit)
  }

  disconnect() {
    window.removeEventListener("resize", this.fit)
  }

  fit() {
    const top = this.element.getBoundingClientRect().top
    const available = window.innerHeight - top - this.gapValue
    this.element.style.maxHeight = `${Math.max(this.minValue, Math.round(available))}px`
  }
}
